import { REDUX_ACTIONS } from '../../shared/config/constants';
const initialState = {
  loading: false,
  deleting: false,
  data: [],
  unModifiedData: [],
  units: {},
  errorMessage: '',
  loadingDelete: false,
  saved: false,
  paginatedElements: 0,
  drillDetails: {
    loading: false,
    hydraulicsDrillDetails: {},
    units: {}
  },
  details: {
    unModifiedData: [],
    data: [],
    units: {},
    paginatedElements: 0,
  },
  mudPumps: {
    data: [],
    units: {},
    paginatedElements: 0,
  },
  downloadModel: 'idle',
  downloadRolloverPDF: 'idel',
  downloadRampSchedulePDF: 'idel',
  downloadESDECDChart: 'idel',
  drillFluidProperty: {
    data: [],
  },
  downloadWellsRunPdf: 'idel',
  downloadParametricAnalysisPdf: 'idel',
  downloadDisplacementPdf: 'idle',
  chartXAxis: {
    min: '',
    max: '',
  },
  chartYAxis: {
    min: '',
    max: '',
  },
  hydraulicsRunResults: {
    data: {},
    units: {},
    paginatedElements: 0,
    loading: true
  },
};
const hydraulicsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.HYDRAULICS_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: ''
      };
    case REDUX_ACTIONS.HYDRAULICS_LOADING_FALSE:
      return {
        ...state,
        loading: false,
        errorMessage: ''
      };
    case REDUX_ACTIONS.HYDRAULICS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.payload.data],
        unModifiedData: [...action.payload.unModifiedData],
        units: {
          inputs: { ...state.units?.inputs, ...action.payload?.units?.inputs },
          results: { ...state.units?.results, ...action.payload?.units?.results }
        },
        permissions: action?.payload?.permissions ?? state?.permissions ?? {},
        paginatedElements: action.payload.paginatedElements,
        errorMessage: ''
      };
    case REDUX_ACTIONS.HYDRAULICS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: []
      };
    case REDUX_ACTIONS.HYDRAULICS_SET_ID:
      return {
        ...state,
        hydraulicsId: action.payload.data
      };
    case REDUX_ACTIONS.HYDRAULICS_LIST_ERROR_NOTIFIED:
      return {
        ...state,
        errorMessage: '',
        data: []
      };
    case REDUX_ACTIONS.HYDRAULICS_DETAILS_LIST_LOADING:
      return {
        ...state,
        details: {
          ...state.details,
          loading: true,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_DETAILS_LIST_SUCCESS:
      return {
        ...state,
        units: {
          inputs: { ...state.units?.inputs, ...action.payload?.units?.inputs },
          results: { ...state.units?.results, ...action.payload?.units?.results }
        },
        details: {
          ...state.details,
          loading: false,
          unModifiedData: [...action.payload.unModifiedData],
          data: [...action.payload.data],
          units: { ...action.payload.units },
          paginatedElements: action.payload.paginatedElements,
          permissionId: action?.payload?.permissionId ?? null,
          permissions: action?.payload?.permissions ?? state?.details?.permissions ?? {},
          createdDetails: action?.payload?.lastUpdate
            ? {
                createdBy: action?.payload?.createdBy,
                lastUpdate: action?.payload?.lastUpdate,
                lastUpdatedBy: action?.payload?.lastUpdatedBy
              }
            : state?.details?.createdDetails,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_DETAILS_LIST_ERROR:
      return {
        ...state,
        details: {
          ...state.details,
          loading: false,
          errorMessage: action.payload.message,
          data: []
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_DETAILS_LIST_SET_FALSE:
      return {
        ...state,
        details: {
          ...state.details,
          loading: false,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_DRILL_DETAILS_LOADING:
      return {
        ...state,
        drillDetails: {
          ...state.drillDetails,
          errorMessage: '',
          loading: true,
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_DRILL_DETAILS_SUCCESS:
      return {
        ...state,
        drillDetails: {
          ...state.drillDetails,
          loading: false,
          units: { ...action.payload.units },
          hydraulicsDrillDetails: { ...action.payload.data },
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_DRILL_DETAILS_ERROR:
      return {
        ...state,
        drillDetails: {
          ...state.drillDetails,
          loading: false,
          errorMessage: action.payload.message,
          hydraulicsDrillDetails: { ...action.payload.data }
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_DRILL_DETAILS_RESET:
      return {
        ...state,
        drillDetails: {
          ...state.drillDetails,
          loading: false,
          errorMessage: action.payload.message,
          hydraulicsDrillDetails: { }
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_RESET:
      return {
        ...initialState
      };
    case REDUX_ACTIONS.HYDRAULICS_MUD_PUMPS_LIST_LOADING:
      return {
        ...state,
        mudPumps: {
          ...state.mudPumps,
          loading: true,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_MUD_PUMPS_LIST_SUCCESS:
      return {
        ...state,
        mudPumps: {
          ...state.mudPumps,
          loading: false,
          data: [...action.payload.data],
          units: { ...action.payload.units },
          paginatedElements: action.payload.paginatedElements,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_MUD_PUMPS_LIST_ERROR:
      return {
        ...state,
        mudPumps: {
          ...state.mudPumps,
          loading: false,
          errorMessage: action.payload.message,
          data: []
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_DOWNLOAD_MODEL_LOADING:
      return {
        ...state,
        downloadModel: 'loading'
      };
    case REDUX_ACTIONS.HYDRAULICS_DOWNLOAD_MODEL_IDLE:
      return {
        ...state,
        downloadModel: 'idle'
      };
    case REDUX_ACTIONS.HYDRAULICS_DOWNLOAD_MODEL_ERROR:
      return {
        ...state,
        downloadModel: 'error'
      };
    case REDUX_ACTIONS.DOWNLOAD_RAMP_SCHEDULE_PDF_LOADING:
      return {
        ...state,
        downloadRampSchedulePDF: 'loading'
      };
    case REDUX_ACTIONS.DOWNLOAD_RAMP_SCHEDULE_PDF_IDLE:
      return {
        ...state,
        downloadRampSchedulePDF: 'idle'
      };
    case REDUX_ACTIONS.DOWNLOAD_RAMP_SCHEDULE_PDF_ERROR:
      return {
        ...state,
        downloadRampSchedulePDF: 'error'
      };
    case REDUX_ACTIONS.DOWNLOAD_ECD_ESD_PDF_LOADING:
      return {
        ...state,
        downloadESDECDChart: 'loading'
      };
    case REDUX_ACTIONS.DOWNLOAD_ECD_ESD_PDF_IDLE:
      return {
        ...state,
        downloadESDECDChart: 'idle'
      };
    case REDUX_ACTIONS.DOWNLOAD_ECD_ESD_PDF_ERROR:
      return {
        ...state,
        downloadESDECDChart: 'error'
      };
    case REDUX_ACTIONS.DOWNLOAD_ROLLOVER_PDF_LOADING:
      return {
        ...state,
        downloadRolloverPDF: 'loading'
      };
    case REDUX_ACTIONS.DOWNLOAD_ROLLOVER_PDF_IDLE:
      return {
        ...state,
        downloadRolloverPDF: 'idle'
      };
    case REDUX_ACTIONS.DOWNLOAD_ROLLOVER_PDF_ERROR:
      return {
        ...state,
        downloadRolloverPDF: 'error'
      };
    case REDUX_ACTIONS.WELLS_DRILL_FLUID_PROPERTY_LIST_LOADING:
      return {
        ...state,
        drillFluidProperty: {
          ...state.drillFluidProperty,
          loading: true,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.WELLS_DRILL_FLUID_PROPERTY_LIST_SUCCESS:
      return {
        ...state,
        drillFluidProperty: {
          ...state.drillFluidProperty,
          loading: false,
          data: [...action.payload.data],
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.WELLS_DRILL_FLUID_PROPERTY_LIST_ERROR:
      return {
        ...state,
        drillFluidProperty: {
          ...state.drillFluidProperty,
          loading: false,
          errorMessage: action.payload.message,
          data: []
        }
      };
    case REDUX_ACTIONS.WELLS_DRILL_FLUID_PROPERTY_RESETLIST:
      return {
        ...state,
        drillFluidProperty: {
          ...state.drillFluidProperty,
          loading: false,
          data: []
        }
      };
    case REDUX_ACTIONS.DOWNLOAD_WELLS_RUN_PDF_LOADING:
      return {
        ...state,
        downloadWellsRunPdf: 'loading'
      };
    case REDUX_ACTIONS.DOWNLOAD_WELLS_RUN_PDF_IDLE:
      return {
        ...state,
        downloadWellsRunPdf: 'idle'
      };
    case REDUX_ACTIONS.DOWNLOAD_WELLS_RUN_PDF_ERROR:
      return {
        ...state,
        downloadWellsRunPdf: 'error'
      };
    case REDUX_ACTIONS.DOWNLOAD_PARAMETRIC_PDF_LOADING:
      return {
        ...state,
        downloadParametricAnalysisPdf: 'loading'
      };
    case REDUX_ACTIONS.DOWNLOAD_PARAMETRIC_PDF_IDLE:
      return {
        ...state,
        downloadParametricAnalysisPdf: 'idle'
      };
    case REDUX_ACTIONS.DOWNLOAD_PARAMETRIC_PDF_ERROR:
      return {
        ...state,
        downloadParametricAnalysisPdf: 'error'
      };
    case REDUX_ACTIONS.DOWNLOAD_DISPLACEMENT_PDF_LOADING:
      return {
        ...state,
        downloadDisplacementPdf: 'loading'
      };
    case REDUX_ACTIONS.DOWNLOAD_DISPLACEMENT_PDF_IDLE:
      return {
        ...state,
        downloadDisplacementPdf: 'idle'
      };
    case REDUX_ACTIONS.DOWNLOAD_DISPLACEMENT_PDF_ERROR:
      return {
        ...state,
        downloadDisplacementPdf: 'error'
      };
    case REDUX_ACTIONS.SET_HYDRAULICS_ECD_CHARTS_XAXIS:
      return {
        ...state,
        chartXAxis: {
          min: action.payload.min,
          max: action.payload.max
        }
      };
    case REDUX_ACTIONS.SET_HYDRAULICS_ECD_CHARTS_YAXIS:
      return {
        ...state,
        chartYAxis: {
          min: action.payload.min,
          max: action.payload.max
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_RUN_RESULT_LIST_LOADING:
      return {
        ...state,
        hydraulicsRunResults: {
          ...state.hydraulicsRunResults,
          loading: true,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_RUN_RESULT_LIST_SUCCESS:
      return {
        ...state,
        hydraulicsRunResults: {
          ...state.hydraulicsRunResults,
          data: { ...action.payload.data },
          units: { ...action.payload.units },
          paginatedElements: action.payload.paginatedElements,
          loading: false,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_RUN_RESULT_LIST_ERROR:
      return {
        ...state,
        hydraulicsRunResults: {
          ...state.hydraulicsRunResults,
          loading: false,
          errorMessage: action.payload.message,
          data: {}
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_RUN_RESULT_LIST_RESET:
      return {
        ...state,
        hydraulicsRunResults: {
          ...state.hydraulicsRunResults,
          loading: false,
          errorMessage: '',
          data: {}
        }
      };
    default:
      return state;
  }
};
export default hydraulicsReducer;
